export function closeGetRegulationResultsFetch() {
    return {
        type: 'API_GET_REGULATION_RESULTS_CLOSE_FETCH',
    }
}

export function closeCreateRegulationResultsFetch() {
    return {
        type: 'API_CREATE_REGULATION_RESULTS_CLOSE_FETCH',
    }
}

export function closeUpdateRegulationResultsFetch() {
    return {
        type: 'API_UPDATE_REGULATION_RESULTS_CLOSE_FETCH',
    }
}

export function clearRegulationResultError() {
    return {
        type: 'CLEAR_REGULATION_RESULT_ERRORS',
    }
}

export function getRegulationResults(companyId) {
    return {
        type: 'API_GET_REGULATION_RESULTS',
        payload: {
            request: {
                method: 'GET',
                url: `/companies/${companyId}/regulation_results`
            }
        }
    }
}

export function createRegulationResult(regulation_result, companyId) {
    return {
        type: 'API_CREATE_REGULATION_RESULT',
        payload: {
            request: {
                method: 'POST',
                url: `/companies/${companyId}/regulation_results`,
                data: regulation_result,
            }
        }
    }
}

export function updateRegulationResult(regulation_result) {
    return {
        type: 'API_UPDATE_REGULATION_RESULT',
        payload: {
            request: {
                method: 'PUT',
                url: `/regulation_results/${regulation_result.id}`,
                data: regulation_result,
            }
        }
    }
}

export function setEditRegulationResult(regulation_result) {
    return {
        type: 'SET_EDIT_REGULATION_RESULT',
        payload: {
            regulation_result: regulation_result
        },
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/regulation_results.js